// extracted by mini-css-extract-plugin
module.exports = {"textDanger":"Jd_textDanger__2bho8","textBold":"Jd_textBold__1CBsS","textSuccess":"Jd_textSuccess__32ZpB"};